export default __webpack_public_path__ + "static/media/Stack_Push.c3066a5e.gif";